<template>
  <v-container>
    <v-dialog
      ref="datedialog"
      v-model="datemodal"
      :return-value.sync="date"
      persistent
      lazy
      full-width
      width="290px"
      @input="changeDate"
    >
      <template v-slot:activator="{ on }">
        <div class="form-control">
          <input
            type="text"
            v-model="date"
            label="Picker in dialog"
            prepend-icon="event"
            readonly
            v-on="on"
            style="display: inline-block; width: auto"
          />
        </div>
      </template>
      <v-date-picker v-model="date" scrollable>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="datemodal = false">Cancel</v-btn>
        <v-btn flat color="primary" @click="$refs.datedialog.save(date)">OK</v-btn>
      </v-date-picker>
    </v-dialog>

    <NvbbSummaryDrinkPhytoShotDetail :date="shippingDate">
      <span slot="header">สรุปยอดผลิต ของวันที่ {{ produceDate | dateFormat('DD/MM/YYYY') }}</span>
    </NvbbSummaryDrinkPhytoShotDetail>

    <NvbbSummaryDrinkPhytoShotDetail :date="shippingDate">
      <span slot="header"
        >สรุปยอดจัดส่ง ของวันที่ {{ shippingDate | dateFormat('DD/MM/YYYY') }}</span
      >
    </NvbbSummaryDrinkPhytoShotDetail>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import api from '@/api'
import NvbbSummaryDrinkPhytoShotDetail from './NvbbSummaryDrinkPhytoShotDetail'
export default {
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      data: {},
      datemodal: false,
      loading: true,
      total: {
        small: 0,
        big: 0
      }
    }
  },
  components: {
    NvbbSummaryDrinkPhytoShotDetail
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    produceDate() {
      try {
        return moment(this.date).format('YYYY-MM-DD')
      } catch (error) {
        return false
      }
    },
    shippingDate() {
      try {
        return moment(this.date).add(1, 'days').format('YYYY-MM-DD')
      } catch (error) {
        return false
      }
    }
  },
  async mounted() {},
  methods: {
    async changeDate() {
      // this.loading = true
      // try {
      //   var response = await this.get_nvbb_product_amount_by_date()
      //   if (response.responsecode == 200) {
      //   }
      //   this.data = response.data
      //   this.total = {
      //     small: 0,
      //     big: 0,
      //   }
      //   if (this.data && this.data.length > 0) {
      //     this.total = this.data.reduce(
      //       (prev, curr) => {
      //         return {
      //           small: prev.small + curr.small,
      //           big: prev.big + curr.big,
      //         }
      //       },
      //       {
      //         small: 0,
      //         big: 0,
      //       }
      //     )
      //   }
      // } catch (error) {
      //   console.log(error)
      // }
      // this.loading = false
    },
    get_nvbb_product_amount_by_date() {
      var data = {
        pageid: this.selectedBot.pageid,
        tab: 'phytomylk',
        date: this.date
      }
      return new Promise((resolve, reject) => {
        api.get_nvbb_product_amount_by_date(data, (error, response) => {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/NvbbSummaryDrinkPhytoShot.vue